// extracted by mini-css-extract-plugin
module.exports = {"companyLogo":"RenderInputs_companyLogo__3sjD5"};